import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { get24HrTime, getDur, capitalizeFirstLetter, getRouteInfo, getImgPath } from '../../common/common';
import { amens } from '../common/icons/svg';
import { updateSeatChart } from '../../actions/editPolicy-actions';
import store from '../../store';

class Listing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            seat: ''
        }
    }

    getDateFromToday = (no_of_days) => {
        var cur = new Date();
        var dateFromToday = new Date();
        dateFromToday.setDate(cur.getDate() + no_of_days);
        return dateFromToday;
    }

    showDiscount = (val) => {
        if (val.DiscountAmt > 0) {
            return <div>&#8377;{val.Fare - val.DiscountAmt}</div>;
        }
        if (val.DiscountPer > 0) {
            return <div>&#8377;{Math.round(val.Fare - (val.Fare * val.DiscountPer / 100))}</div>;
        }
        return <div>&#8377;{val.Fare}</div>;
    }

    showDiscountTag = (val) => {
        if (val.DiscountPer > 0) {
            return <div style={this.discountTag} className="discountTag right">{val.DiscountPer}% Off</div>;
        }
        if (val.DiscountAmt > 0) {
            return <div style={this.discountTag} className="discountTag right">&#8377;{val.DiscountAmt} Off</div>;
        }
    }

    showAmenities = (val) => {
        val = val.split(',');
        if (val.length > 0) {
            return (
                <div style={{ position: 'relative' }}>
                    {
                        val.map((amen, index) => {
                            if (index < 4) {
                                return <span key={index} alt={amen} title={amen} style={{
                                    width: '25px', height: '25px', paddingRight: '8px'
                                }}>{amens(amen.toLowerCase().split(' ').join('-'))}</span>;
                            } else if (val.length > 4 && index === (val.length - 1)) {
                                return <span key={index} style={{
                                    color: window.color['searchBoxBgColor'],
                                    fontSize: '1em',
                                    position: 'absolute',
                                    top: '5px'
                                }}>
                                    {(val.length - 4) + '+'}
                                </span>;
                            }
                        })
                    }
                </div>
            );
        }
        else {
            return '';
        }
    }

    openSeatChart = (e, rsid, deptTime) => {
        let data = this.props.editPolicy.data.APIGetBookingDetailsResult[0];
        if (!this.props.editPolicy.stChrtOthrDtls[rsid]) {
            getRouteInfo(rsid);
        }
        store.dispatch(updateSeatChart(rsid, true));
        if (this.props.editPolicy.stChrtStatus[rsid]) {
            this.props.history.push('/seatcharts/' + rsid + '/' + data.FromCityID + '/' + data.FromCityName + '/' + data.ToCityID + '/' + data.ToCityName + '/' + data.JourneyDate + '/oneway/' + this.props.match.params.pnrNo + '/' + deptTime);
        }
    }

    render() {

        let APIGetBookingDetailsResult = this.props.editPolicy.data.APIGetBookingDetailsResult[0];
        let fromCityName = APIGetBookingDetailsResult.FromCityName;
        let toCityName = APIGetBookingDetailsResult.ToCityName;
        const loop = this.props.editPolicy.buses;

        if (loop.length > 0) {

            return loop.map(el => {
                let departTime = el.DepartureTime;
                let val = departTime.split(/[^0-9]/);
                const departureTime = new Date(val[0], val[1] - 1, val[2], val[3], val[4], val[5]);
                let currTime = new Date();
                
                if (departureTime.getTime() > currTime.getTime()) {
                    const disFare = el.DiscountPer > 0 || el.DiscountAmt > 0 ? true : false;
                    return (
                        <div key={el.RouteScheduleId} className='srch-card left' onClick={(event) => this.openSeatChart(event, el.RouteScheduleId, el.DepartureTime)}>
                            <div className='srch-box left' style={{ width: '100%' }}>
                                <div className='left bus-time' style={{ width: '65%' }}>
                                    <div className='departure-time font15'>
                                        {get24HrTime(el.DepartureTime)}
                                    </div>
                                    <div className='journeytime font14-light'>
                                        <div className="arrow1" style={{ padding: '0 5px 0 10px' }}>
                                            <span className="line1 left" style={{
                                                marginTop: '-6px',
                                                width: '12px',
                                                background: '#999',
                                                height: '1px'
                                            }}></span>
                                        </div>
                                        {getDur(el.DepartureTime, el.ArrivalTime)}
                                        <div className="arrow2" style={{ padding: '0 10px 0 5px' }}>
                                            <span className="line2 left" style={{
                                                marginTop: '4px',
                                                width: '12px',
                                                background: '#999',
                                                height: '1px'
                                            }}></span>
                                            <span className="point left" style={{
                                                width: '0',
                                                height: '0',
                                                borderTop: '5px solid transparent',
                                                borderBottom: '4px solid transparent',
                                                borderLeft: '5px solid #999'
                                            }}></span>
                                        </div>
                                    </div>
                                    <div className='arrival-time font15'>
                                        {get24HrTime(el.ArrivalTime)}
                                    </div>
                                </div>
                                <div className='right price' style={{ width: '35%' }}>
                                    <div className="font14-light" style={{
                                        display: 'inline-block',
                                        paddingRight: '5px'
                                    }}>
                                        <strike>{disFare ? '₹' + el.Fare : ''}</strike>
                                    </div>
                                    <div className="font15" style={{
                                        color: window.color['buttonColor'],
                                        display: 'inline-block'
                                    }}>
                                        {this.showDiscount(el)}
                                    </div>
                                </div>
                                <div className='left font14-light' style={{ width: '100%' }}>
                                    <div className='left bus-type' style={{ width: '75%', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>
                                        {el.HasAC ? 'AC ' : ''}
                                        {el.HasNAC ? 'Non AC ' : ''}
                                        {el.HasSeater ? 'Seater ' : ''}
                                        {el.HasSleeper ? 'Sleeper ' : ''}
                                        {el.BusType.toLowerCase()}
                                        {el.Suffix ? ' - ' + el.Suffix.toLowerCase() : ''}
                                    </div>
                                    <div className='right available-seat' style={{ width: '25%' }}>
                                        {disFare ? this.showDiscountTag(el) : ''}
                                        <div className='right' style={{
                                            width: '100%'
                                        }}>
                                            {el.AvailableSeats} Seats
                                        </div>
                                    </div>
                                </div>
                                <div className='left font14-light' style={{ width: '100%' }}>
                                    <div className='left srchbox-amenities' style={{ width: '55%', marginTop: '15px' }}>
                                        {el.AmenitiesType ? this.showAmenities(el.AmenitiesType) : ''}
                                    </div>
                                    <div className='right srchbox-companyName' style={{
                                        marginTop: '15px',
                                        width: '45%',
                                        paddingLeft: '10px',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden'
                                    }}>
                                        {el.CompanyName.toLowerCase()}
                                    </div>
                                </div>
                            </div>
                        </div>

                    )
                } else {
                    return <div style={{ textAlign: 'center', padding: '5px', color: '#ff1f70' }}>Sorry! There were no results found for {fromCityName} to {toCityName} - Please Modify your Search in the search box above.</div>
                }
            })
        } else if (loop.length === 0) {
            if (this.props.editPolicy.data.length > 0) {
                return <div>No results found</div>
            } else {
                return (
                    <div className='loading'>
                        Loading...
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                )
            }
        } else {
            return <div style={{ textAlign: 'center', padding: '5px', color: '#ff1f70' }}>Sorry! There were no results found for {fromCityName} to {toCityName} - Please Modify your Search in the search box above.</div>
        }
    }
}

const mapStateToProps = function (store) {
    return (store);
};

export default connect(mapStateToProps)(withRouter(Listing));


// WEBPACK FOOTER //
// ./src/components/listing/Listing.js